/**
 * Geo helpers for printable map boundary thumbnails and header coordinates.
 */

export function getGeojsonCentroid(geojson) {
  const coords = geojson?.type === 'Polygon' ? geojson.coordinates?.[0] : null;
  if (!Array.isArray(coords) || coords.length === 0) return null;
  let sumLng = 0;
  let sumLat = 0;
  coords.forEach(([lng, lat]) => {
    sumLng += lng;
    sumLat += lat;
  });
  return { lat: sumLat / coords.length, lng: sumLng / coords.length };
}

export function geojsonToSvgPolygonPoints(geojson) {
  const coords = geojson?.type === 'Polygon' ? geojson.coordinates?.[0] : null;
  if (!Array.isArray(coords) || coords.length === 0) return '';

  let minLng = Infinity;
  let minLat = Infinity;
  let maxLng = -Infinity;
  let maxLat = -Infinity;
  coords.forEach(([lng, lat]) => {
    minLng = Math.min(minLng, lng);
    maxLng = Math.max(maxLng, lng);
    minLat = Math.min(minLat, lat);
    maxLat = Math.max(maxLat, lat);
  });

  const pad = 0.1;
  const width = maxLng - minLng || 1;
  const height = maxLat - minLat || 1;

  return coords
    .map(([lng, lat]) => {
      const x = pad * 100 + ((lng - minLng) / width) * (100 - 2 * pad * 100);
      const y = pad * 100 + (1 - (lat - minLat) / height) * (100 - 2 * pad * 100);
      return `${x},${y}`;
    })
    .join(' ');
}
